/* eslint-disable */

import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import RNPickerSelect from 'react-native-picker-select';

import Icon from './Icon';
import Text from './Text';
import Image from './Image';

import { t } from '../../utils/appUtils';
import { IS_WEB, IS_ANDROID, IS_IOS } from '../../lib/appConstants';
import { getByValue } from '../../utils/utils';

import {
  FONT_FAMILY,
  BASE_COLOR,
  FORM_WIDTH,
  BUTTON_HEIGHT,
  SAFE_OFFSET,
  FONT_FAMILY_BOLD,
  GOLDEN200,
  pOrT,
} from '../styleConstants';

let Picker: any;
if (IS_WEB) {
  Picker = (window as any).Picker;
}

const styles = StyleSheet.create({
  container: {},
  label: {
    color: 'rgba(236, 203, 180, 0.6)',
    fontSize: pOrT(9, 11),
    marginTop: 5,
    marginLeft: 10,
    zIndex: 9,
  },
  value: {
    fontSize: pOrT(11, 12),
    zIndex: 9,
    color: GOLDEN200,
    marginLeft: 10,
    marginTop: 10,
  },
  pickerWeb: (IS_WEB
    ? {
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        fontSize: 0,
        cursor: 'pointer',
        position: 'absolute',
        zIndex: 5,
        borderWidth: 0,
        backgroundColor: 'transparent',
      }
    : null) as any,
});

type Props = {
  data: { key: string | number; label: string }[];
  placeholder?: string;
  value: string | number | null | undefined;
  style?: any;
  onChange: Function;
  hint?: string;
  label?: string;
};

type State = {
  value: string | number | null | undefined;
  pickerValue: string | number | null | undefined;
  showPicker: boolean;
};

let pickerRef: any;
let picker: any;

export function hidePicker() {
  if (IS_WEB) return;

  if (IS_IOS && pickerRef && pickerRef.state.showPicker) {
    pickerRef.togglePicker();
  }

  if (IS_ANDROID && picker && picker.state.showPicker) {
    picker.hidePickerAndroid();
  }
}

export default class extends PureComponent<Props, State> {
  pickerRef: any;

  constructor(props: Props) {
    super(props);

    const value = props.value ? props.value : null;
    this.state = {
      value,
      pickerValue: value,
      showPicker: true,
    };

    picker = this;
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== undefined) {
      (this.state as any).value = nextProps.value;
      (this.state as any).pickerValue = nextProps.value;
    }
  }

  onValueChange = (value: any) => {
    const { onChange } = this.props;

    const key = Number(value) == value ? Number(value) : value; // eslint-disable-line
    if (IS_WEB || IS_ANDROID) {
      this.setState({ value: key });
      onChange(key);
    } else {
      this.setState({ pickerValue: key });
    }
  };

  onDonePress = () => {
    const { onChange } = this.props;
    const { pickerValue } = this.state;

    this.setState({ value: pickerValue });
    onChange(pickerValue);
  };

  onClose = () => {
    setTimeout(() => {
      this.setState((state) => ({
        pickerValue: state.value,
      }));
    }, 500);
  };

  hidePickerAndroid = () => {
    // Hack to close picker on android
    this.setState(
      {
        showPicker: false,
      },
      () => {
        this.setState({ showPicker: true });
      },
    );
  };

  getValue() {
    const { data } = this.props;
    const { value } = this.state;
    const item = getByValue(data, value, 'key');
    return item ? item.label : null;
  }

  render() {
    const { placeholder, style, data, label, hint } = this.props;
    const { value, pickerValue, showPicker } = this.state;

    const width = label ? FORM_WIDTH : 148;
    return (
      <View style={[styles.container, { width }, style]}>
        <View style={{ position: 'absolute', backgroundColor: 'transparent' }}>
          {label ? (
            <Text bold style={[styles.label, { width }]}>
              {label}
              {hint ? ` (${hint})` : ''}
            </Text>
          ) : null}
          <Text bold style={styles.value}>
            {this.getValue() || placeholder || ''}
          </Text>
          <Image
            style={{
              width,
              height: label ? 55 : BUTTON_HEIGHT,
              position: 'absolute',
            }}
            source={require('../../assets/images/inputBar.png')}
          />
          <Image
            style={{
              position: 'absolute',
              top: label ? 24 : 14,
              left: label ? FORM_WIDTH - 20 : 128,
              width: 12,
              height: 12,
            }}
            source={require('../../assets/images/arrowDown.png')}
          />
        </View>

        {IS_WEB ? (
          <Picker
            style={[
              styles.pickerWeb,
              {
                width,
                height: label ? 55 : BUTTON_HEIGHT,
              },
            ]}
            selectedValue={value || undefined}
            onValueChange={this.onValueChange}
          >
            {data.map((item) => (
              <Picker.Item key={item.key} label={item.label} value={item.key} />
            ))}
          </Picker>
        ) : showPicker ? (
          <RNPickerSelect
            {...({
              items: data.map((item) => ({ value: item.key, label: item.label })),
              onValueChange: this.onValueChange,
              onDonePress: this.onDonePress,
              onClose: this.onClose,
              placeholder: {},
              value: pickerValue,
              doneText: t('apply'),
              useNativeAndroidPickerStyle: false,
              Icon: () => null,
              ref: (el: any) => {
                pickerRef = el;
              },
              style: {
                done: {
                  marginRight: SAFE_OFFSET,
                },
                chevronUp: {
                  display: 'none',
                },
                chevronDown: {
                  display: 'none',
                },
                placeholder: {
                  color: 'transparent',
                },
                inputIOS: {
                  width,
                  height: label ? 55 : BUTTON_HEIGHT,
                  color: 'transparent',
                },
                inputAndroid: {
                  width,
                  height: label ? 55 : BUTTON_HEIGHT,
                  color: 'transparent',
                },
              },
            } as any)}
          />
        ) : null}
      </View>
    );
  }
}
